import {Form, Input, Submit} from 'components/form'
import {Link} from 'react-router-dom'
import {string, object} from 'yup'
import {AuthService} from 'rest'
import {useStore} from 'rest/stores'
import {useState} from 'react'
import APP_CONFIG from 'constants/clientConfigs'

export const PasswordReminderForm = () => {
  const {textColor = '', hoverTextColor} =
    APP_CONFIG[process.env.REACT_APP_CLIENT_ID]

  const {NotificationStore} = useStore()
  const [success, setSuccess] = useState(false)
  const schema = object({
    email: string().required(),
  })

  const onSubmit = async data => {
    // try {
    await AuthService.postApiAuthForgotPassword({...data, siteId: 2})
      .then(() => setSuccess(true))
      .catch(err => {
        err.status === 404
          ? NotificationStore.handle('No User Found')
          : NotificationStore.handle(err)
        setSuccess(false)
      })
  }

  return (
    <div className="flex min-h-full flex-1 md:pb-48">
      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div>
            <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
              Password Reminder
            </h2>
            <p className="mt-2 text-sm/6 text-gray-500">
              Enter your email address below and we&apos;ll send you a reset
              instructions.{' '}
              <Link
                to="/login"
                className={`font-semibold ${textColor} ${hoverTextColor}`}>
                Go back to sign in
              </Link>
            </p>
          </div>

          <div className="mt-10">
            <div>
              <Form
                schema={schema}
                onSubmit={onSubmit}
                className="flex flex-1 flex-col sm:min-w-[360px]">
                <div className="mt-6">
                  <Input
                    name="email"
                    label="Email address"
                    type="email"
                    placeholder="Enter your email address"
                  />
                </div>

                <Submit className="primary mt-6">SEND INSTRUCTIONS</Submit>

                {!!success && (
                  <div className="text-lime-700 text-sm mt-2 mx-auto w-72 text-center">
                    Your password request was successfully sent. Check your
                    email inbox for further instructions.
                  </div>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
